import { useParams } from 'react-router-dom';
import { MafertAppModuleDetailPage } from './MafertAppModulesPage';

export function MafertAppModuleDetailRoute() {
  const { id } = useParams();
  return <MafertAppModuleDetailPage moduleId={id} />;
}
